<template>
  <div class="qualification-container">
    <div class="tab-container">
      <!-- 라디오 버튼을 v-model로 바인딩하여 선택된 탭 추적 -->
      <input type="radio" id="tab-special" name="tab" class="tab-radio" value="special" v-model="selectedTab">
      <input type="radio" id="tab-general" name="tab" class="tab-radio" value="general" v-model="selectedTab">

      <div class="tab-buttons">
        <label for="tab-special" class="tab-button" :class="{ active: selectedTab === 'special' }">특별공급</label>
        <label for="tab-general" class="tab-button" :class="{ active: selectedTab === 'general' }">일반공급</label>
      </div>

      <!-- 특별공급 내용 -->
      <div v-if="selectedTab === 'special'" class="special-content">
        <h1 class="main-title">특별공급 제출서류</h1>

        <!-- 공지 사항 -->
        <!-- <div class="notice-box">
          <h2 class="section-title">공지사항</h2>
          <ul class="notice-list">
            <li class="notice-item">본 공고의 모집공고일은 2025. 01. 17 (월)이며, 이는 청약자격의 판단기준일 입니다.</li>
            <li class="notice-item">모든 제출서류는 임차인 모집공고일 이후 발행분에 한하여 접수 가능합니다.</li>
            <li class="notice-item">당첨 후 담첨자 서류제출 기간 내 상기 자격확인 서류를 방문 또는 홈페이지를 통해 제출(스캔본)의 방법으로 제출하고,
              서류 미제출 또는 부적격자로 확인될 경우 계약 체결 및 입주자 사전점검등의 절차 진행이 불가할 수 있습니다.</li>
            <li class="notice-item">입주자 필수 주차공간에 자동차 등록 요청 세대의 경우 자동차 등록 유형(장애인, 유자녀, 생업용, 생업용 이륜차)을 구분하여 해당하는 증빙서류 일체를
              계약 시 제출해야 합니다.</li>
            <li class="notice-item">예비 신혼부부 자격의 계약자는 입주 전까지 혼인 사실에 대한 증명서류(혼인관계증명서, 가족관계증명서 등)를 제출하지 않으실 경우
              해당 임차인의 입주를 제한하고 당첨을 취소하거나 임대차 계약이 중도 해지될 수 있습니다.</li>
            <li class="notice-item">신청자의 착오로 인하여 잘못 접수된 청약신청분의 당첨으로 인한 당첨취소 및 부적격 결과는 신청자 본인의 책임입니다.</li>
            <li class="notice-item">입주자격 조사결과에 따른 '부적격사유'에 대한 소명 의무는 전적으로 신청자에게 있습니다.</li>
          </ul>
          <div class="notice-section">
            <p class="notice-subtitle">※ 소득자료 유의사항</p>
            <ul class="notice-list">
              <li class="notice-item">신청인이 소득이 있는 경우</li>
              <li class="notice-item">“해당세대” 월평균 소득 합계가 전년도(2024년) 도시근로자 가구원수별(태아 포함) 가구당 월평균소득의 120% 이하</li>
              <li class="notice-item">① 단독세대주인 경우 신청자 본인만의 소득</li>
              <li class="notice-item">② 세대원 또는 세대원이 있는 세대주인 경우 해당 세대 모두의 소득</li>
              <li class="notice-item">신청인이 소득이 없는 경우</li>
              <li class="notice-item">사실증명서(소득없음) 증빙 후 신청자와 부모의 월평균소득 합계가 전년도(2024년) 도시근로자 가구원수별 가구당 월평균소득의 120% 이하</li>
            </ul>
          </div>
        </div> -->
        <p style="padding: 5px;">- 청약자격의 판단은 모집공고일을 기준으로 합니다.</p>
        <p style="padding: 5px;">- 모든 제출서류는 임차인 모집공고일 이후 발행분에 한하여 접수 가능합니다.</p>

        <!-- 제출서류 표 -->
        <div class="documents-table-container">
          <table class="documents-table">
            <thead>
              <tr>
                <th colspan="5">제출 서류</th>
                <th>발급처</th>
                <th>유의사항</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="5">
                  1. 신분증 사본 (주민등록증, 여권, 운전면허증 중 택1)
                </td>
                <td rowspan="5" style="text-align: center; vertical-align: middle;">행정복지센터, 구청,<br> 시청, 정부24(인터넷)</td>
                <td rowspan="5"></td>
              </tr>
              <tr>
                <td colspan="5">
                  2. 주민등록등본 (세대구성정보, 주민등록번호 뒷자리 등 전체 포함)
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  3. 주민등록초본 (과거 주소변동사항 등 전체 포함)
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  4. 지역우선공급 증빙자료 (재학증명서, 재직증명서 등)
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  5. 가족관계증명서 (상세, 주민등록번호 뒷자리 공개)
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  6. 금융정보 등 (금융·신용·보험정보) 제공 동의서
                </td>
                <td rowspan="5" style="text-align: center; vertical-align: middle;">홈페이지에서 양식 다운로드</td>
                <td rowspan="5"></td>
              </tr>
              <tr>
                <td colspan="5">
                  7. 월평균 소득 (해당 세대원 전체) 및 자산 현황 확인서
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  8. 공급신청서
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  9. 서약서
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  10. 개인정보 제공 동의서
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  11. 지방세 세목별 과세증명서 (세목 전체 / 과세 · 미과세 내역 전체 포함), (서울시 내역 1부, 전국 내역 1부)
                  <p style="font-weight: bold;">과세기간 : 작년부터 올해까지</p>
                  <p class="sub-text">*무주택 및 자산 등 확인</p>
                  <p class="sub-text"> - 청년 : 본인만 출력 제출</p>
                </td>
                <td style="text-align: center; vertical-align: middle;">행정복지센터, 구청,<br> 시청, 정부24(인터넷)</td>
                <td style="text-align: center; vertical-align: middle;">반드시 동사무소, 구청, 시청 직접 방문 하여 발급</td>
              </tr>
              <tr>
                <td rowspan="7" style="text-align: center; vertical-align: middle;">소득 자료</td>
                <td colspan="4">
                  12. 건강보험 자격 득실 확인서 (해당 세대원 전체)
                </td>
                <td>국민건강보험공단,<br> 정부24(인터넷)</td>
                <td rowspan="7" style="text-align: center; vertical-align: middle;">
                  <h3 style="padding-bottom: 15px;">소득여부 확인 후 해당 항목 택1</h3>
                  <p style="text-align: left;">모집공고일 이후<br>
                      세대가 변동된 경우 모집공고일<br>
                      기준 세대구성원의 월평균<br>
                      소득현황 제출</p>
                  <br>
                  <p style="font-weight: bold;">과세기간 : 작년부터 올해까지</p>
                </td>
              </tr>
              <tr>
                <td rowspan="6" style="text-align: center; vertical-align: middle;">
                  13.
                </td>
                <td colspan="2" style="text-align: center; vertical-align: middle;">
                  무소득자
                </td>
                <td>
                  사실증명
                  <p>(신고사실 없음)</p>
                </td>
                <td>세무서, 홈택스(인터넷)</td>
                <!-- <td rowspan="6" style="text-align: center; vertical-align: middle;">
                  <p>- 소득여부 확인 후 해당 항목 택1</p>
                  <p>- 모집공고일 이후 세대가 변동된 경우 모집공고일 기준 세대구성원의 월평균 소득현황 제출</p>
                </td> -->
              </tr>
              <tr>
                <td rowspan="5" style="text-align: center; vertical-align: middle;">
                  소득자
                </td>
                <td>
                  일반근로자
                </td>
                <td>
                  전년도 근로소득원천징수영수증
                  <p>(재직증명서 포함)</p>
                </td>
                <td>해당 직상, 세무서, 홈택스(인터넷)</td>
              </tr>
              <tr>
                <td>
                  신규취업자
                </td>
                <td>
                  금년도 근로소득원천징수영수증
                  <p>(재직증명서 포함)</p>
                </td>
                <td>해당 직장</td>
              </tr>
              <tr>
                <td>
                  개인사업자
                </td>
                <td>
                  전년도 소득금액증명원
                  <p>(사업자등록증 포함)</p>
                </td>
                <td>세무서, 홈택스(인터넷)</td>
              </tr>
              <tr>
                <td>
                  신규사업자
                </td>
                <td>
                  <p>국민연금보험료납입증명서,</p>
                  <p>연금산정용가입내역확인서</p>
                  <p>(사업자등록증 포함)</p>
                </td>
                <td>국민연금관리공단, 세무서, 홈택스(인터넷)</td>
              </tr>
              <tr>
                <td>
                  법인사업자
                </td>
                <td>
                  전년도 소득금액증명원
                  <p>(사업자등록증 포함)</p>
                </td>
                <td>세무서, 홈택스(인터넷)</td>
              </tr>
              <tr>
                <td rowspan="5" style="text-align: center; vertical-align: middle;">
                  자산 자료
                </td>
                <td colspan="4">
                  14.자산보유 사실 확인서
                  <p class="sub-text">- 계좌정보통합관리서비스에서 본인명의(금융, 주식, 보험 등 전체) 발급 후 작성</p>
                  <p class="sub-text">- 주거래 은행에서 신용정보조회서 본인명의(대출 전체) 발급 후 작성</p>
                </td>
                <td>홈페이지에서 양식 다운로드</td>
                <td rowspan="4" style="text-align: center; vertical-align: middle;">
                  부동산 및 자동차 등의 자산자료는 제출하신 지방세세목별과세 증명서로 확인
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  ※ 계좌정보통합관리서비스 내역서 첨부
                  <p class="sub-text">- 전체 내역(각각의 상세내역 전체)</p>
                </td>
                <td>
                  금융결제원(인터넷)
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  ※ 신용정보조회서 첨부
                  <p class="sub-text">- 전체 내역(각각의 상세내역 전체)</p>
                </td>
                <td>주거래 은행</td>
              </tr>
              <tr>
                <td colspan="4">
                  15. 거주지 임대차 계약서(사본, 해당자만 제출)
                </td>
                <td>현재 거주하고 있는 주택이
                  전 · 월세인 경우</td>
              </tr>
              <tr>
                <td colspan="4">
                  16. 자동차(이륜차 포함) 가액 확인 자료
                </td>
                <td style="text-align: center; vertical-align: middle;">
                  보험개발원 또는 복지로 포털
                </td>
                <td style="text-align: center; vertical-align: middle;">
                  자동차 소유자인 경우
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  17. 그 외 자격확인을 위하여 사업주체가 요구하는 서류
                </td>
              </tr>
            </tbody>
          </table>
          
          <p class="sub-text">- 당첨 후 당첨자 서류제출 기간 내 상기 자격확인 서류를 방문 또는 e-mail의 방법으로 제출해야 하며, 서류 미제출 또는 부적격자로 확인 될 경우 입주자 사전점검 및 계약체결 진행이 불가할 수 있습니다.</p>
          <p class="sub-text">- 신청자의 착오로 인하여 잘못 접수된 청약신청분의 당첨으로 인한 당첨취소 및 부적격 결과는 신청자 본인의 책임입니다.</p>
          <p class="sub-text">- 입주자격 조사결과에 따른 ‘부적격사유’에 대한 소명 의무는 전적으로 청약신청자에게 있습니다.</p>
        
        </div>
      </div>

      <!-- 일반공급 내용 -->
      <div v-if="selectedTab === 'general'" class="general-content">
        <h1 class="main-title">일반공급 제출서류</h1>

        <!-- 공지 사항 -->
          <ul class="notice-list">
            <li class="notice-item">청약자격의 판단은 모집공고일을 기준으로 합니다.</li>
            <li class="notice-item">모든 제출서류는 임차인 모집공고일 이후 발행분에 한하여 접수 가능합니다.</li>
          </ul>

        <div class="documents-table-container">
          <table class="documents-table">
            <thead>
              <tr>
                <th colspan="2">제출서류</th>
                <th>발급처</th>
                <th>유의사항</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="3" style="text-align: center; vertical-align: middle;">
                  공통
                </td>
                <td >
                  1. 신분증 사본(주민등록증, 여권, 운전면허증 中 택 1)
                  <p class="sub-text">※ 신혼부부, 예비신혼부부의 경우 배우자 및 예비 배우자의 신분증 사본 추가</p>
                </td>
                <td rowspan="4" style="text-align: center; vertical-align: middle;">
                  행정복지센터, 구청, 시청, 정부24(인터넷)
                </td>
                <td rowspan="4"></td>
              </tr>
              <tr>
                <td>
                  2. 주민등록등본(세대구성정보, 주민등록번호 뒷자리 등 전체 포함)
                  <p class="sub-text">※ 신혼부부의 경우 배우자 세대분리 시 “배우자의 주민등록등본“ 추가</p>
                </td>
              </tr>
              <tr>
                <td>
                  3. 가족관계증명서(상세, 주민등록번호 뒷자리 공개)
                </td>
              </tr>
              <tr>
                <td style="text-align: center; vertical-align: middle;">신혼부부</td>
                <td>
                  4. 혼인관계증명서(신청자 본인 기준, 주민등록번호 뒷자리 공개)
                  <p class="sub-text">* 예비신혼부부의 경우 “예비신혼부부 신청 확인서” 추가 (입주 전 혼인신고 및 혼인관계증명서 제출 필수)</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  5. 공급신청서
                </td>
                <td rowspan="3" style="text-align: center; vertical-align: middle;">
                  홈페이지에서 양식 다운로드
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  6. 서약서
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  7. 개인정보 제공 동의서
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  8. 자동차(이륜차 포함)가액 확인 자료
                </td>
                <td style="text-align: center; vertical-align: middle;">
                  보험개발원 또는 복지로
                </td>
                <td style="text-align: center; vertical-align: middle;">
                  자동차 소유자인 경우
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  9. 지방세 세목별 과세증명서 (세목 전체 / 과세 · 미과세 내역 전체 포함), (서울시 내역 1부, 전국 내역 1부)
                  <p style="font-weight: bold;">과세기간 : 작년부터 올해까지</p>
                  <p class="sub-text">
                    * 예비신혼부부의 경우 “예비신혼부부 신청 확인서” 추가 (입주 전 혼인신고 및 혼인관계증명서 제출 필수)<br>
                    * 무주택 확인<br>
                    - 청년 : 본인만 출력하여 제출<br>
                    - 신혼부부 : 해당 세대원 모두 출력 제출<br>
                    - 예비신혼부부 : 예비신혼부부 2인 모두 출력 제출
                  </p>
                </td>
                <td style="text-align: center; vertical-align: middle;">
                  행정복지센터, 구청, 시청, 정부24(인터넷)
                </td>
                <td style="text-align: center; vertical-align: middle;">반드시 동사무소, 구청, 시청 직접 방문 하여 발급</td>
                </tr>
              <tr>
                <td colspan="2">
                  10. 그 외 자격확인을 위하여 사업주체가 요구하는 서류
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <p class="sub-text">- 당첨 후 당첨자 서류제출 기간 내 상기 자격확인 서류를 방문 또는 e-mail의 방법으로 제출해야 하며, 서류 미제출 또는 부적격자로 확인 될 경우 입주자 사전점검 및 계약체결 진행이 불가할 수 있습니다.</p>
          <p class="sub-text">- 예비신혼부부 자격의 계약자는 입주 전까지 혼인 사실에 대한 증명서류(혼인관계증명서, 가족관계증명서 등)를 제출하지 않으실 경우 해당 임차인의 입주를 제한하고 당첨을 취소하거나 임대차 계약이 중도해지될 수 있습니다.</p>
          <p class="sub-text">- 신청자의 착오로 인하여 잘못 접수된 청약신청분의 당첨으로 인한 당첨취소 및 부적격 결과는 신청자 본인의 책임입니다.</p>
          <p class="sub-text">- 입주자격 조사결과에 따른 ‘부적격사유’에 대한 소명 의무는 전적으로 공급신청자에게 있습니다.</p>

        </div>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedTab: 'special',  // 기본 선택된 탭 설정
    };
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}

.style-none {
  list-style-type: none;
}

.qualification-container {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  color: #333;
  line-height: 1.6;
}

/* 제목 스타일 */
.main-title {
  font-size: 24px;
  font-weight: 700;
  margin: 20px 0;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

/* 탭 컨테이너 및 버튼 */
.tab-container {
  position: relative;
  margin-bottom: 30px;
}

.tab-radio {
  display: none;
  /* 라디오 버튼 숨김 */
}

.tab-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.tab-button {
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: #e0e0e0;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 5px;
  transition: all 0.3s ease;
  text-align: center;
}

.tab-button.active {
  background-color: #4a6b82;
  color: white;
}

/* 공지사항 박스 */
.notice-box {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.notice-subtitle {
  font-weight: 600;
  margin: 15px 0 5px 0;
}

.notice-section {
  margin-top: 15px;
}

/* 리스트 스타일 */
.notice-list {
  list-style-type: none;
  padding-left: 5px;
  margin-bottom: 10px;
}

.notice-item {
  position: relative;
  padding-left: 15px;
  margin-bottom: 8px;
}

.notice-item:before {
  content: "·";
  position: absolute;
  left: 0;
  color: #666;
}

/* 제출서류 표 스타일 */
.documents-table-container,
.income-documents-container,
.additional-documents {
  margin-bottom: 30px;
  overflow-x: auto;
}

.documents-table,
.income-documents-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
}

.documents-table {
  width: 100%;
  max-width: 1400px; /* ✅ 더 넓게 설정 */
  border-collapse: collapse;
  border-spacing: 0;
}

.documents-table th,
.documents-table td,
.income-documents-table th,
.income-documents-table td {
  border: 1px solid #ddd;
  padding: 12px 15px;
  text-align: left;
  vertical-align: top;
}

.documents-table th,
.income-documents-table th {
  background-color: #f2f2f2;
  font-weight: 600;
  text-align: center;
}

.documents-table th:first-child {
  width: 50%;
}

.documents-table th:nth-child(2),
.documents-table th:nth-child(3) {
  width: 25%;
}

.sub-text {
  font-size: 13px;
  color: #666;
  margin-top: 5px;
}

/* 소득증빙서류 표 스타일 */
.income-documents-table .category {
  background-color: #f9f9f9;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
}

.income-documents-table .sub-category {
  background-color: #f9f9f9;
  width: 120px;
}

.income-documents-table .document-list p,
.income-documents-table .note p {
  margin-bottom: 5px;
}

/* 하이라이트 박스 */
.highlight-box {
  background-color: #f0f7ff;
  padding: 10px;
  border-radius: 5px;
}

.highlight-box p {
  margin-bottom: 5px;
}

/* 다운로드 섹션 */
.download-section {
  margin: 30px 0;
  text-align: center;
}

.download-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}

.download-button {
  background-color: #4a6b82;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.download-button:hover {
  background-color: #3a5a72;
}

/* 준비 중 메시지 */
.coming-soon {
  text-align: center;
  font-size: 18px;
  margin: 50px 0;
  color: #666;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .qualification-container {
    padding: 15px;
  }

  .main-title {
    font-size: 20px;
  }

  .tab-button {
    padding: 8px 15px;
    font-size: 14px;
  }

  .documents-table th,
  .documents-table td,
  .income-documents-table th,
  .income-documents-table td {
    padding: 8px;
    font-size: 14px;
  }

  .sub-text {
    font-size: 12px;
  }
}
</style>